import {useEffect, useState} from "react";
import {API, Entities} from "../../utils/Api";
import {normalizeImgUrlToThumb} from "../../utils/Helper";

export function PresentersGrid({presenters,filters}){

    return(
        <section className="pt-0 ps-6 pe-6 xxl-ps-4 xxl-pe-4 lg-px-0">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 filter-content">
                        <ul className="portfolio-boxed portfolio-wrapper grid-loading grid grid-4col xxl-grid-4col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-large text-center mt-4">
                            <li key={0} className="grid-sizer"></li>
                            {
                                presenters.map((presenter,idx)=>{

                                    return <PresenterItem {...presenter} key={idx}/>}
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export function PresenterItem({imgUrl,idx,category,filters=[],name,id,companyName,awards}){
    const awardItems = JSON.parse(awards);
    const firstAwardKey = Object.keys(awardItems)[0];      // '58' – stringként jön!
    const firstAward = awardItems[firstAwardKey];           // '2024 - Különdíjas'

    var thumbUrl=normalizeImgUrlToThumb(imgUrl);
    return (
        <li key={idx+1} className={"grid-item transition-inner-all"}>
            <div className="portfolio-box border-radius-4px">
                <div className="portfolio-image border-radius-4px">
                    <img src={thumbUrl>''?thumbUrl:'https://placehold.co/800x635'} alt=""/>
                    <div className="portfolio-hover d-flex justify-content-center flex-column">
                        <div
                            className="portfolio-icon d-flex flex-row justify-content-center align-items-center">
                            <a href={"eloado/"+id}
                               className="d-flex flex-column justify-content-center text-dark-gray text-dark-gray-hover rounded-circle bg-white w-60px h-60px move-bottom-top">
                                <i className="fa-solid fa-plus icon-small" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div className="portfolio-overlay bg-dark-gray"
                         style={{backgroundColor: "#637c8e"}}></div>
                </div>
                <div className="portfolio-caption pt-30px pb-30px lg-pt-20px lg-pb-20px">

                    <a href={`eloado/${id}`} className="fs-17 fw-700 text-dark-gray text-dark-gray-hover lh-1">
                        {name}
                    </a>
                    <br/>

                    <a href={`eloado/${id}`} className="fs-17 fw-500 text-dark-gray text-dark-gray-hover mb-2 lh-1">
                        {companyName || <span style={{ visibility: 'hidden' }}>X</span>}
                    </a>
                    <br/>

                    <a href={`eloado/${id}`} className="fs-17 fw-400 text-dark-gray text-dark-gray-hover">
                        {firstAward || <span style={{ visibility: 'hidden' }}>X</span>}
                    </a>
                    <br/>
                </div>
            </div>
        </li>
    )
}

export function ExhibitorsGrid({exhibitors,filters}){
    return(
        <section className="pt-0 ps-6 pe-6 xxl-ps-4 xxl-pe-4 lg-px-0">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 filter-content">
                        <ul className="portfolio-boxed portfolio-wrapper grid-loading grid grid-4col xxl-grid-4col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-large text-center">
                            <li key={0} className="grid-sizer"></li>
                            {
                                exhibitors.map((exhibitor,idx)=>{
                                    return <ExhibitorItem {...exhibitor} key={idx}/>}
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export function ExhibitorItem({imgUrl,idx,externalUrl,filters=[],name,id}){

    var thumbUrl= normalizeImgUrlToThumb(imgUrl);
    return (
        <li key={idx+1} className={"grid-item transition-inner-all"}>
            <div className="portfolio-box border-radius-4px">
                <div className="portfolio-image border-radius-4px">
                    <img src={thumbUrl>''?thumbUrl:'https://placehold.co/800x635'} alt=""/>
                    <div className="portfolio-hover d-flex justify-content-center flex-column">
                        <div
                            className="portfolio-icon d-flex flex-row justify-content-center align-items-center">
                            <a href={externalUrl} target={'_blank'}
                               className="d-flex flex-column justify-content-center text-dark-gray text-dark-gray-hover rounded-circle bg-white w-60px h-60px move-bottom-top">
                                <i className="fa-solid fa-plus icon-small" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div className="portfolio-overlay bg-dark-gray"
                         style={{backgroundColor: "#637c8e"}}></div>
                </div>
                <div className="portfolio-caption pt-30px pb-30px lg-pt-20px lg-pb-20px lh-normal text-start ms-4 me-4">
                    <a href={externalUrl}
                       className="fs-17 fw-400 text-dark-gray text-dark-gray-hover" dangerouslySetInnerHTML={{__html:name}}></a>
                </div>
            </div>
        </li>
    )
}


export function TeamGrid() {
    const filters = ['digital', 'branding', 'design', 'brochure'];
    const data = [
        {
            'imgUrl': "/benefitshare/img/csapat.jpg",
            'category': 'design',
            'name': 'Pixflow',
            'filters': ['design', 'web']
        },
        {
            'imgUrl': "/benefitshare/img/csapat.jpg",
            'category': 'digital',
            'name': 'Pixflow',
            'filters': ['design', 'web']
        },
        {
            'imgUrl': "/benefitshare/img/csapat.jpg",
            'category': 'branding',
            'name': 'Pixflow',
            'filters': ['design', 'web']
        },
        {
            'imgUrl': "/benefitshare/img/csapat.jpg",
            'category': 'digital',
            'name': 'Pixflow',
            'filters': ['design', 'web']
        },
        {
            'imgUrl': "/benefitshare/img/csapat.jpg",
            'category': 'brochure',
            'name': 'Pixflow',
            'filters': ['design', 'web']
        },
        {
            'imgUrl': "/benefitshare/img/csapat.jpg",
            'category': 'digital',
            'name': 'Pixflow',
            'filters': ['design', 'web']
        }
    ];

    return (
        <section className="position-relative">
            <div className="container">
                <div className="row align-items-center mb-4 appear anime-child anime-complete"
                     data-anime={JSON.stringify({
                         "el": "childs",
                         "translateY": [30, 0],
                         "opacity": [0, 1],
                         "duration": 600,
                         "delay": 0,
                         "staggervalue": 300,
                         "easing": "easeOutQuad"
                     })}>
                    <div className="col-xl-5 lg-mb-30px text-center text-xl-start">
                        <h3 className="text-dark-gray fw-700 mb-0 ls-minus-2px">Csapatunk</h3>
                    </div>
                    <div className="col-xl-7 tab-style-04 text-center text-xl-end">
                        <ul className="portfolio-filter nav nav-tabs justify-content-center justify-content-xl-end border-0 fw-500">
                            <li key={0} className="nav">
                                <a data-filter="*" href="#">Összes</a>
                            </li>
                            {
                                filters.map((filter, idx) => {
                                    return <li key={idx + 1} className="nav">
                                        <a data-filter={"." + filter} href="#">{filter.toUpperCase()}</a>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className="row appear anime-complete"
                     data-anime={JSON.stringify({
                         "opacity": [0, 1],
                         "duration": 600,
                         "delay": 0,
                         "staggervalue": 300,
                         "easing": "easeOutQuad"
                     })}
                >
                    <div className="col-12 filter-content p-md-0">
                        <ul className="portfolio-modern portfolio-wrapper grid grid-3col xxl-grid-3col xl-grid-3col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-extra-large"
                            style={{position: "relative", height: "471.188px"}}>
                            <li key={0} className="grid-sizer"></li>
                            {
                                data.map((member, idx) => {
                                    return <TeamMemberItem idx={idx} {...member}/>
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}


export function TeamMemberItem({idx, imgUrl, filters, category, name, href = null}) {
    return (
        <li key={idx + 1} className={"grid-item " + filters.join(' ') + " " + category + " transition-inner-all"}
            style={{position: "absolute", left: "66.6598%", top: "0px"}}>
            <a {...(href ? {href} : {})}>
                <div className="portfolio-box">
                    <div className="portfolio-image border-radius-6px">
                        <img src={imgUrl} alt="" data-no-retina=""/>
                    </div>
                    <div className="portfolio-hover box-shadow-extra-large">
                        <div
                            className="bg-white d-flex align-items-center align-self-end text-start border-radius-4px ps-30px pe-30px pt-20px pb-20px lg-p-20px w-100">
                            <div className="me-auto">
                                <div
                                    className="fs-12 fw-500 text-medium-gray text-uppercase lh-24">{category}
                                </div>
                                <div
                                    className="fw-700 text-dark-gray text-uppercase lh-initial">{name}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    )

}